import React from 'react'

import { BarChart, DashboardChartPaper } from 'components'

import { routes } from 'Routes'
import theme from 'theme'

const ConsentsByForm = ({ consentForms, id }) => {
  const titles = consentForms?.map((form) => form.title)
  const authorizedConsents = consentForms?.map((form) => form.authorized)
  const revokedConsents = consentForms?.map((form) => form.revoked)

  return (
    <DashboardChartPaper
      title="Quantidade de Consentimentos e Revogações por Formulário"
      subtitle="Quantidade de consentimentos e de revogações por formulário (10 primeiros)"
      redirect={routes.consent.all}
    >
      <BarChart
        id={id}
        names={titles}
        series={[
          { name: 'Consentimentos', data: authorizedConsents || [] },
          { name: 'Revogações', data: revokedConsents || [] },
        ]}
        heightValue={250}
        colors={[
          theme.palette.dashboard.chart.consents.authorized,
          theme.palette.dashboard.chart.consents.revoked,
        ]}
        showLabels
      />
    </DashboardChartPaper>
  )
}

export default ConsentsByForm
